import { Transaction } from './Transaction';

export class PaymentHistory {
  public transactions: Transaction[];
  public openingBalance: number;
  public closingBalance: number;
  public totalInvoiceAmount: number;
  public totalReceiptAmount: number;
}
